import React from 'react';

import useSystemBranding from '../hooks/useSystemBranding';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { copyrightText } = useSystemBranding();
  const leftText = copyrightText ?? `© ${currentYear} All rights reserved.`;

  return (
    <footer className="px-6 py-2 min-h-(--listing-footer-height) border-t border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-950 flex flex-col sm:flex-row items-center justify-between text-xs text-neutral-500 dark:text-neutral-400 gap-2 shrink-0">
      <div>{leftText}</div>
      <div>
        Designed and Developed by{' '}
        <a
          href="https://www.hiddenbrains.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-neutral-900 dark:text-white decoration-2 underline-offset-2 hover:underline"
        >
          Hidden Brains
        </a>
      </div>
    </footer>
  );
};

export default Footer;
